import {
  fleetCriticalTriple,
  fleetEngineStart,
  fleetEngineStop,
  fleetGeofenceEnter,
  fleetGeofenceExit,
  fleetGpsLost,
  fleetGpsRestored,
  fleetInfoPing,
  fleetNotification,
  fleetOverspeedAlert,
  fleetPowerCut,
  fleetPowerRestored,
  fleetSosEmergency,
  fleetTamperAlert,
  fleetWarningDouble,
} from "./sounds";

// Keep all web notification sounds on the fleet_notification pack.
// Older saved keys are aliased here so existing settings continue to work.
export const SOUND_MAP = {
  default: fleetNotification,
  info: fleetInfoPing,
  warning: fleetWarningDouble,
  critical: fleetCriticalTriple,
  mute: null,

  // Backward-compatible aliases for older saved web sound keys
  sos: fleetSosEmergency,
  towing: fleetNotification,
  overspeed: fleetOverspeedAlert,
  fuel_theft: fleetTamperAlert,
  low_battery: fleetWarningDouble,
  tamper_alert: fleetTamperAlert,
  sos_emergency: fleetSosEmergency,
  overspeed_alert: fleetOverspeedAlert,

  // Engine
  engine_start: fleetEngineStart,
  engine_stop: fleetEngineStop,
  fleet_engine_start: fleetEngineStart,
  fleet_engine_stop: fleetEngineStop,

  // Geofence
  geofence_entry: fleetGeofenceEnter,
  geofence_exit: fleetGeofenceExit,
  geofence_enter: fleetGeofenceEnter,
  fleet_geofence_exit: fleetGeofenceExit,

  // GPS
  gps_lost: fleetGpsLost,
  gps_restored: fleetGpsRestored,
  signal_lost: fleetGpsLost,

  // Device / power aliases
  device_connected: fleetNotification,
  device_disconnected: fleetPowerCut,
  offline: fleetPowerCut,

  power_on: fleetPowerRestored,
  power_off: fleetPowerCut,
  power_cut: fleetPowerCut,
  power_restored: fleetPowerRestored,

  // Driving aliases
  harsh_acceleration: fleetWarningDouble,
  harsh_braking: fleetWarningDouble,
  idle_too_long: fleetWarningDouble,

  // Fleet notification pack
  notification: fleetNotification,
  info_ping: fleetInfoPing,
  warning_double: fleetWarningDouble,
  critical_triple: fleetCriticalTriple,
  fleet_gps_lost: fleetGpsLost,
  fleet_gps_restored: fleetGpsRestored,
};

const LABELS = {
  default: "DEFAULT FLEET NOTIFICATION",
  info: "INFO PING",
  warning: "WARNING DOUBLE",
  critical: "CRITICAL TRIPLE",
  mute: "MUTE",
  signal_lost: "FLEET GPS LOST",
  notification: "DEFAULT FLEET NOTIFICATION",
  info_ping: "FLEET INFO PING",
  warning_double: "FLEET WARNING DOUBLE",
  critical_triple: "FLEET CRITICAL TRIPLE",
  fleet_engine_start: "FLEET ENGINE START",
  fleet_engine_stop: "FLEET ENGINE STOP",
  geofence_enter: "FLEET GEOFENCE ENTER",
  fleet_geofence_exit: "FLEET GEOFENCE EXIT",
  power_cut: "FLEET POWER CUT",
  power_restored: "FLEET POWER RESTORED",
  sos_emergency: "FLEET SOS EMERGENCY",
  tamper_alert: "FLEET TAMPER ALERT",
  overspeed_alert: "FLEET OVERSPEED ALERT",
  fleet_gps_lost: "FLEET GPS LOST",
  fleet_gps_restored: "FLEET GPS RESTORED",
};

const DROPDOWN_SOUND_KEYS = [
  "notification",
  "info_ping",
  "warning_double",
  "critical_triple",
  "mute",
  "tamper_alert",
  "sos_emergency",
  "overspeed_alert",
  "fleet_engine_start",
  "fleet_engine_stop",
  "geofence_enter",
  "fleet_geofence_exit",
  "power_cut",
  "power_restored",
  "fleet_gps_lost",
  "fleet_gps_restored",
];

export const SOUND_OPTIONS = DROPDOWN_SOUND_KEYS.map((key) => ({
  value: key,
  label: LABELS[key] || key.replaceAll("_", " ").toUpperCase(),
}));
